import { SxStyles } from 'types';

import { YEARS_PER_ROW } from '../../const';

export const root: SxStyles = {
  display: 'grid',
  gridTemplateColumns: `repeat(${YEARS_PER_ROW}, 1fr)`,
  gap: '8px',
};
